import posthog from 'posthog-js'

export function initPostHog() {
  if (typeof window !== 'undefined' && import.meta.env.VITE_POSTHOG_KEY) {
    posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
      api_host: import.meta.env.VITE_POSTHOG_HOST || 'https://app.posthog.com',
      autocapture: false, // Manual tracking for better control
      capture_pageview: true, // Manual page view tracking
      capture_pageleave: true, // Track when users leave
      persistence: 'localStorage+cookie',
      session_recording: {
        maskAllInputs: true, // Mask all input fields for privacy
        maskAllText: false, // Don't mask regular text
      },
      loaded: (posthog) => {
        if (import.meta.env.DEV) {
          // In development, log events to console
          console.log('[Analytics] PostHog loaded', posthog)
        }
      }
    })
  }
}

export function identifyUser(userId: string, properties?: Record<string, any>) {
  if (typeof window !== 'undefined' && window.posthog) {
    posthog.identify(userId, properties)

    if (import.meta.env.DEV) {
      console.log('[Analytics] User identified:', userId, properties)
    }
  }
}

export function trackEvent(event: string, properties?: Record<string, any>) {
  if (typeof window !== 'undefined' && window.posthog) {
    posthog.capture(event, {
      ...properties,
      $timestamp: new Date().toISOString(),
    })

    if (import.meta.env.DEV) {
      console.log('[Analytics]', event, properties)
    }
  }
}

export function resetUser() {
  if (typeof window !== 'undefined' && window.posthog) {
    posthog.reset()
  }
}

export function setUserProperties(properties: Record<string, any>) {
  if (typeof window !== 'undefined' && window.posthog) {
    posthog.people.set(properties)

    if (import.meta.env.DEV) {
      console.log('[Analytics] User properties set:', properties)
    }
  }
}

export function trackPageView(path?: string) {
  if (typeof window !== 'undefined' && window.posthog) {
    posthog.capture('$pageview', {
      $current_url: path || window.location.href,
    })
  }
}

// Pre-configured dashboards to create in PostHog
export const POSTHOG_DASHBOARDS = {
  onboardingFunnel: {
    name: 'Onboarding Funnel',
    charts: [
      'Main Funnel (7 steps)',
      'Drop-off Analysis',
      'Time to Activation',
      'Method Comparison (OAuth vs Email)',
    ],
  },
  realTimeMonitoring: {
    name: 'Real-Time Onboarding',
    charts: [
      'Active Users by Step',
      'Live Completion Rate',
      'Current Bottlenecks',
      'Error Events',
    ],
  },
  cohortAnalysis: {
    name: 'Cohort Performance',
    charts: [
      'Weekly Cohort Retention',
      'Trial vs Free Comparison',
      'Activation by Source',
      'Team Size Impact',
    ],
  },
}

// Type definitions for window.posthog
declare global {
  interface Window {
    posthog?: typeof posthog
  }
}